import React from 'react';
import {
  InlineNotification,
  NotificationActionButton
} from 'carbon-components-react';

const ReferralWarning: React.FC<any> = ({
  handleToggle,
  setIsWarningModal
}) => {
  const handleCloseButton = () => {
    setIsWarningModal(false);
  };
  return (
    <div className="referral-warning-filter">
      <div className="referral-warning-filter-main">
        <InlineNotification
          lowContrast
          iconDescription="close"
          title="Warning"
          subtitle="Are you sure you want to pause referrals?"
          kind="warning"
          actions={
            <NotificationActionButton onClick={handleToggle}>
              {'Yes, pause'}
            </NotificationActionButton>
          }
          onCloseButtonClick={handleCloseButton}
        />
      </div>
    </div>
  );
};
export default ReferralWarning;
